<app-dialog [subtitle]="appAlert.alertDialog.title"
            data-testid="alert-dialog"
            [hideIcon]="true">
    @if (message) {
        <form-item-text [subtitle]="message"></form-item-text>
    }
    @if(messages.length){
        @for (message of messages; track message) {
            <form-item-text [subtitle]="message"></form-item-text>
        }
    }
    <form-action-buttons [justify]="'center'">
        <form-button [subtitle]="appAlert.alertDialog.okButtonText"
                     [btnType]="'confirm'"
                     (click)="appAlert.closeAlertDialog()">
        </form-button>
    </form-action-buttons>
</app-dialog>
